import { render, staticRenderFns } from "./rechangRank.vue?vue&type=template&id=4e7a305f"
import script from "./rechangRank.vue?vue&type=script&lang=js"
export * from "./rechangRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports